/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-19 14:31:03
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-29 15:29:13
 * @FilePath: /unifyxp-v2-store-portal/src/components/Upload/EditModal/CropModal.tsx
 */
import { Input } from 'antd';
import React, { useEffect, useState } from 'react';

import { Button, Modal, Select } from '@/src/components/Antd';
import Cropper from 'react-cropper';

import { getImageWidthNHeight } from '@/src/tools/helper';

import 'cropperjs/dist/cropper.css';
import styles from './css.less';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

type Props = {
  ratio: number;
  originalName: string;
  src: string;
  visible: boolean;
  onCancel: () => void;
  onOk: (info: any) => void;
};

const CropModal = ({
  onOk,
  ratio,
  originalName,
  visible,
  onCancel,
  src,
}: Props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const ref = React.createRef<HTMLImageElement>();

  const [type, setType] = useState('fixed');

  const [imageInfo, setImageInfo] = useState({ width: 0, height: 0 });
  const [canvasInfo, setCanvasInfo] = useState({
    width: 0,
    height: 0,
    zoomRatio: 0,
  });

  const handleCrop = () => {
    const imageElement: any = ref?.current;
    const cropper: any = imageElement?.cropper;
    const info = cropper.getCropBoxData();
    const { height, naturalHeight } = cropper.getImageData();
    const ratio = naturalHeight / height;
    onOk({
      top: info.top * ratio,
      left: info.left * ratio,
      width: info.width * ratio,
      height: info.height * ratio,
    });
  };

  const handleCropEnd = () => {
    const imageElement: any = ref?.current;
    const cropper: any = imageElement?.cropper;
    const { width, height } = cropper.getCropBoxData();
    setImageInfo({ width: +width.toFixed(), height: +height.toFixed() });
  };

  const handleChangeCropType = (value) => {
    setType(value);
    if (value === 'fixed') {
      const imageElement: any = ref?.current;
      const cropper: any = imageElement?.cropper;
      cropper.setAspectRatio(ratio);
    }
    if (value === 'random') {
      const imageElement: any = ref?.current;
      const cropper: any = imageElement?.cropper;
      cropper.setAspectRatio(NaN);
    }
  };

  const handleChangeImageInfo = (type, e) => {
    const value = e.target.value;
    setImageInfo({ ...imageInfo, [type]: value });
    const imageElement: any = ref?.current;
    const cropper: any = imageElement?.cropper;
    cropper.setCropBoxData({
      left: 20,
      top: 20,
      width: type === 'width' ? +value : imageInfo.width,
      height: type === 'height' ? +value : imageInfo.height,
    });
  };

  useEffect(() => {
    if (src) {
      getImageWidthNHeight(src).then(({ width, height }) => {
        const ratio = width / height;
        if (width < 672 && height < 470) {
          setCanvasInfo({ width, height, zoomRatio: 1 });
          setImageInfo({ width, height });
        }
        if (width >= 672 || height >= 470) {
          if (470 * ratio > 672) {
            setCanvasInfo({
              height: 672 / ratio,
              width: 672,
              zoomRatio: width / 672,
            });
            setImageInfo({ height: 672 / ratio, width: 672 });
          } else {
            setCanvasInfo({
              height: 470,
              width: 470 * ratio,
              zoomRatio: height / 470,
            });
            setImageInfo({ height: 470, width: 470 * ratio });
          }
        }
      });
    }
  }, [src]);

  return (
    <Modal
      width={1080}
      visible={visible}
      footer={null}
      className={styles.modal}
      onCancel={onCancel}
      title={getI18n('general.upload.EditModal.crop_image')}>
      <div className={styles.container}>
        <div className={styles.leftContainer}>
          <div className={styles.leftTopContainer}>
            <div className={styles.cropContainer}>
              <Cropper
                style={{
                  maxWidth: canvasInfo.width,
                  maxHeight: canvasInfo.height,
                }}
                aspectRatio={type === 'fixed' ? ratio : NaN}
                movable={false}
                zoomable={false}
                cropend={handleCropEnd}
                src={src}
                guides
                ref={ref}
              />
            </div>
          </div>
          <div className={styles.leftBottomContainer}>
            <div className={styles.line}>
              <Button type={'primary'} onClick={handleCrop}>
                {getI18n('general.confirm')}
              </Button>
              <Button onClick={onCancel}>{getI18n('general.cancel')}</Button>
            </div>
          </div>
        </div>
        <div className={styles.rightContainer}>
          <div className={styles.title}>{originalName}</div>
          <div className={styles.cropOption}>
            <div className={styles.cropTitle}>
              {getI18n('general.upload.EditModal.crop_option')}
            </div>
            <Select
              options={[
                {
                  label: getI18n('general.upload.EditModal.original_ratio'),
                  value: 'fixed',
                },
                {
                  label: getI18n('general.upload.EditModal.resolution'),
                  value: 'random',
                },
              ]}
              onChange={handleChangeCropType}
              value={type}
            />
            <div className={styles.cropTitle}>
              {getI18n('general.upload.EditModal.ratio')}
            </div>
            {type === 'fixed' ? (
              <span>{ratio}</span>
            ) : (
              <>
                <Input
                  className={styles.input}
                  onChange={handleChangeImageInfo.bind(this, 'width')}
                  value={imageInfo.width}
                />
                <span className={styles.multiply}>X</span>
                <Input
                  className={styles.input}
                  onChange={handleChangeImageInfo.bind(this, 'height')}
                  value={imageInfo.height}
                />
              </>
            )}
          </div>
        </div>
      </div>
      <div className={styles.footer}></div>
    </Modal>
  );
};

export default CropModal;
